import * as core from '../../../../../../../core'
import * as proposalStatus from '../proposal-status'

export const RESOURCE = {
  payload: {
    description: '3. In Progress',
    enumId: core.dms.models.Enum.Id.from({
      partialId: proposalStatus.RESOURCE.payload.partialId,
    }),
    id: '3. In Progress',
    name: '3. In Progress',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
